import { Icon } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';

import OfficialPage from '../OfficialPage';

import './CancelOrder.less';

import { TopNav } from '@common/top-nav/TopNav';

export default class CancelOrder extends OfficialPage {
  state = {
    cancelReason: [],
    orderId: '',
    deliverType: 0,
    submitData: {
      order_id: '',
      app_id: '',
      sub_shop_app_id: '',
      refund_reason: '',
      description: '',
      img_url: []
    },
    reasonIndex: '',
    isShowInstruction: false,
    isFromBack: false,
    isShowText: true
  }

  constructor(props) {
    super(props);
    document.title = '取消订单';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.data.orderId = options.orderId
    this.data.deliverType = options.deliverType
    this.data.submitData.app_id = app.getAppId()
    this.data.submitData.sub_shop_app_id = options.franchisee || ''
    this.dataInitial()
  }

  componentDidMount() {
    if (this.data.isFromBack) {
      this.dataInitial()
    } else {
      this.setData({
        isFromBack: true
      })
    }
  }

  componentDidHide() { }

  componentWillUnmount() { }

  onPullDownRefresh = () => { }
  onReachBottom = () => { }
  onShareAppMessage = () => { }
  dataInitial = () => {
    this.getBuyerCancelReason()
  }
  getBuyerCancelReason = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppTransport/getBuyerCancelReason',
      data: {
        deliver_type: this.data.deliverType
      },
      success: function (res) {
        if (res.status === 0) {
          that.setData({
            cancelReason: res.data
          })
        }
      }
    })
  }
  chooseImage = e => {
    var that = this,
      img_url = that.data.submitData.img_url
    if (img_url.length >= 3) {
      app.showModal({
        content: '每个商品最多上传3张图片'
      })
      return
    }
    app.chooseImage(function (images) {
      var data = {}
      data['submitData.img_url'] = img_url.concat(images)
      that.setData(data)
    }, 3 - img_url.length)
  }
  removePic = e => {
    var picIndex = e.currentTarget.dataset.picIndex,
      img_url = this.data.submitData.img_url,
      data = {}
    img_url.splice(picIndex, 1)
    data['submitData.img_url'] = img_url
    this.setData(data)
  }
  chooseReason = e => {
    var chooseIndex = e.currentTarget.dataset.reasonIndex,
      data = {}
    data['submitData.refund_reason'] = chooseIndex
    data.reasonIndex = chooseIndex
    this.setData(data)
  }
  applyDrawback = e => {
    var that = this,
      submitData = that.data.submitData
    submitData.order_id = this.data.orderId
    submitData.app_id = app.getAppId()
    if (!submitData.refund_reason) {
      app.showModal({
        content: '选择一个原因'
      })
      return
    }
    if (submitData.img_url.length > 3) {
      app.showModal({
        content: '最多上传3张图片'
      })
      return
    }
    that.showInstruction()
    that.setData({
      isShowText: false
    })
  }
  showInstruction = () => {
    this.setData({ isShowInstruction: true })
  }
  hideInstruction = () => {
    var that = this,
      submitData = that.data.submitData
    submitData.order_id = this.data.orderId
    submitData.app_id = app.getAppId()
    app.sendRequest({
      url: '/index.php?r=AppShop/applyRefund',
      method: 'post',
      data: submitData,
      success: function (res) {
        that.setData({ isShowInstruction: false })
        app.turnBack()
      },
      complete: function () {
        that.setData({ isShowInstruction: false })
      }
    })
  }
  commentInput = e => {
    this.data.submitData.description = e.target.value
  }

  render() {
    const {
      rewardPointObj,
      shareGiftsObj,
      collectGiftsObj,
      collectGetObj,
      showGetUserInfo,
      cancelReason,
      reasonIndex,
      isShowText,
      submitData,
      isShowInstruction
    } = this.state

    return (
      <div className="official-page cancel-order">
        <TopNav title="取消订单" />
        <React.Fragment>
          <div className="contain">
            <div className="takeoutFeedback">
              <div className="selectFeedback feedbackItem">
                <span>
                  <span style={convertLineStyleData('color: #F2303E;font-size:28rpx;')}>*</span>
                  请选择取消原因
                </span>
              </div>
              {Object.values(cancelReason).map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <div
                      className="feedbackItem"
                      onClick={this.chooseReason}
                      data-reason-index={index}
                      data-reason-str={item}
                    >
                      <span>{item}</span>
                      {index == reasonIndex && (
                        <Icon
                          type="check-circle"
                          color="#FF7100"
                          className="fr"
                        ></Icon>
                      )}
                      {index != reasonIndex && (
                        <label className="circle fr"></label>
                      )}
                    </div>
                  </React.Fragment>
                )
              })}
            </div>
            <div className="takeoutFeedback" style={convertLineStyleData('margin-bottom:40rpx;')}>
              <div style={convertLineStyleData('padding: 30rpx 0;')}>上传凭证（最多上传3张）</div>
              <div className="feedbackInfo">
                {isShowText && (
                  <textarea
                    placeholder="其他补充信息"
                    onInput={this.commentInput}
                  ></textarea>
                )}
              </div>
              <div className="makeCom-pic-container">
                {submitData.img_url.map((imgUrl, index) => {
                  return (
                    <div key={index} className="makeCom-pic-wrap">
                      <img src={imgUrl} mode="aspectFit" />
                      <label
                        className="makeCom-remove-pic"
                        onClick={this.removePic}
                        data-pic-index={index}
                      >
                        ×
                      </label>
                    </div>
                  )
                })}
                {submitData.img_url.length < 3 && (
                  <div className="makeCom-upload-pic" onClick={this.chooseImage}>
                    <div
                      className="ico-moon icon-fn-camera"
                      style={convertLineStyleData('display:block; font-size: 60rpx;')}
                    ></div>
                    <span>添加图片</span>
                  </div>
                )}
              </div>
            </div>
            <div className="bottom-container" onClick={this.applyDrawback}>
              <label className="make-comment">提交</label>
            </div>
            {/*  <view class='instruction-warp' wx:if="{{isShowInstruction}}">  */}
            {isShowInstruction && (
              <div className="instruction-warp">
                <div className="instruction-container">
                  <div>
                    <div className="instruction-container">
                      <div style={convertLineStyleData('padding: 0 27px;')}>
                        <div className="instruction-title">
                          <Icon type="check-circle" color="#FF7100"></Icon>
                          <span>退款申请已提交</span>
                        </div>
                        <span
                          className="instruction-item"
                          style={convertLineStyleData('text-align:center;font-size:26rpx;')}
                        >
                          商家同意后退款将原路退回到您的支付账户,详情请查看订单进度
                        </span>
                      </div>
                      <span
                        className="instruction-close"
                        onClick={this.hideInstruction}
                      >
                        知道了
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/cancel-order/CancelOrder.jsx